export default __webpack_public_path__ + "static/media/skillShuffle.32fa99ad.jpg";